import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_CLASSROOMS_GET',
  GET_SUCCESS: 'STUDENT_CLASSROOMS_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_CLASSROOMS_GET_FAILURE',
  RECORD_AUTO_LEADERBOARD_UPDATE: 'RECORD_AUTO_LEADERBOARD_UPDATE',
  INVALIDATE_ITEM: 'STUDENT_CLASSROOMS_INVALIDATE_ITEM',
};

export const get = actions.get(
  id => `${BASE_URL}/student-classrooms/?teacher_classroom_id=${id}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
    },
  });
};
